<template>
  <div class="page-pagination" ref="pagination">
    <el-pagination
      :align="align"
      :small="small"
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :total="total"
      v-bind="$attrs"
      :pager-count="5"
      @size-change="handleSizeChange" 
      @current-change="handleCurrentChange"
      ></el-pagination>
  </div>
</template>
<script>
export default {
  name: 'pagination',
  props: {
    align: {
      type: String,
      default: 'center'
    },
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 16, 20, 30, 40, 50, 100 ,200,300,500,800,1000]
      }
    },
    layout: {
      type: String,
      default: 'total, prev, pager, next, sizes'
    },
    background: {
      type: Boolean,
      default: true
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('pagination', { page: this.currentPage, limit: val })
    },
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, limit: this.pageSize })
    }
  }
}
</script>
<style scoped>
.page-pagination{
  padding:100px 0 200px
}
.el-pagination{
  display:flex;
  align-items:center;
  justify-content: center;
}
.el-pagination /deep/ .el-pagination__sizes{
  height:auto;
}
.el-pagination.is-background /deep/ .el-pager li:not(.disabled):hover{
  color:#1F8E51;
}
.el-pagination.is-background /deep/ .el-pager li:not(.disabled).active{
  background:#1F8E51;
  color:#fff;
}
</style>


// WEBPACK FOOTER //
// src/components/pagination.vue